

import React, { Component, useState, useEffect } from 'react'
import Select from 'react-select'
import { ApiAdapter } from "./adapters";
import { useTranslation } from "react-i18next";

import {
  collapseTextChangeRangesAcrossMultipleVersions,
  isConstructorDeclaration,
} from "typescript";


const HostControl: React.FC<any> = ({ my_propa }) => {

  var newApi = (my_propa != undefined) ? my_propa : new ApiAdapter();
  var use_api = (my_propa != undefined) ? false : true;
  var [my_prop, set_prop] = useState(my_propa);

  const [api] = useState(newApi);
  const [selectedOption, setSelected] = useState([]);
  const { t, i18n } = useTranslation();

  useEffect(() => {
    var elem = document.getElementById("patient")
    elem.addEventListener("result", reloadApi);
  })
  useEffect(() => {
    var elem = document.getElementById("patient")
    elem.addEventListener("reset", reset);
  })
  useEffect(() => {
    var elem = document.getElementById("patient")
    elem.addEventListener("reset", reset);
  }, [selectedOption])
  const reset = () => {
    set_prop([])    
    setSelected([]);

  }
  useEffect(() => {
    updateWindow()
  }, []);
  
  useEffect(() => {
    updateWindow()
  }, [selectedOption]);

  const updateWindow = () => {
    window["update_preview"]()
  }

  const reloadApi = () => {

    if (use_api) {
      api
        .loadHost()
        .then((resp) => {
          set_prop(resp)
        })
        .catch((errors) => console.log("DELETE_ME handle index errors:", errors));

    }
  }

  const mynoOptionsMessage=(inputValue) => {
    return t("views.show_patient.video_call_invitation.drop_down.host");
  }

  const onChange = selectedOption => {
    if (selectedOption == undefined){
      selectedOption = []
    }
    setSelected(selectedOption);
    window["update_preview"]();
  };



  return (
    <div>
      <Select 
        value={selectedOption}
        id="host_select_control"
        options={my_prop}
        onChange={onChange}
        name="HostControl"
        className="basic-select"
        isClearable="true"
        classNamePrefix="select"
        placeholder={t("views.show_patient.video_call_invitation.drop_down.select_host")}
        noOptionsMessage={mynoOptionsMessage}

      />
      <input key={selectedOption.value + "HostName"} type="hidden" value={selectedOption.value} data_name="host_id" className="host-id custom-control-input" id="video_call_host_id" />
      <input key={selectedOption.value} type="hidden" host_name={selectedOption.label} value={selectedOption.label} className="host-id custom-control-input" id="video_call_host" />
    </div>
  );
}

export default HostControl;